// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagWindowsModel extends SmartTagModel {
	windowType?: string;
	features?: any[];
	materials?: any[];

	constructor() {
		super();

		this.windowType = '';
		this.features = [];
		this.materials = [];
	}
}

export class SmartTagWindows extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagWindowsModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagWindowsModel): void{
		const title = data.title || data.subCategory || '';
		const windowType = data.windowType?.trim() || '';
		const features = data.features || [];
		const materials = data.materials || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (windowType !== '') {
			this.addText(`<span title="${windowType}">WindowType: ${windowType}</span>`);
		}

		if (features && features.length > 0) {
			this.addText(`<span title="Features:">Features:</span>`);
			features.forEach((feature: any) => {
				this.addText(`<span title="${feature.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${feature.typeName}</span>`);
			});
		}

		if (materials && materials.length > 0) {
			this.addText(`<span title="Materials:">Materials:</span>`);
			materials.forEach((material: any) => {
				this.addText(`<span title="${material.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${material.typeName}</span>`);
			});
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
